<template>
  <ContainerBox title="角色技能">
    <div class="tabs">
      <div class="tab-bar">
        <div
          class="bar-item"
          v-for="(key, index) in Object.keys(dataSource.list)"
          :class="{ active: active == index }"
          :key="key + index"
          @click="handleTabChange(index)"
        >
          <img class="icon" :src="dataSource.list[key].icon.value" alt="" />
          <span class="name">
            <span v-if="index < 2">
              {{ "技能" + (index + 1) }}
            </span>
            <span v-else>爆裂技能</span>
            -{{ dataSource.list[key].name.value }}
          </span>
        </div>

        <div class="bar-item" :class="{ active: active == 3 }" @click="handleTabChange(3)">
          <img class="icon" :src="dataSource.ptgj.icon.value" alt="" />
          <span class="name">{{ dataSource.ptgj.name.value }}</span>
        </div>
        <div
          class="bar-item"
          :class="{ active: active == 4 }"
          @click="handleTabChange(4)"
          v-if="dataSource.zcp.icon.hasValue && dataSource.zcp.icon.value"
        >
          <img class="icon" :src="dataSource.zcp.icon.value" alt="" />
          <span class="name">{{ dataSource.zcp.name.value }}</span>
        </div>
      </div>
      <div class="tab-container">
        <div
          class="tab-panel"
          v-for="(key, index) in Object.keys(dataSource.list)"
          :key="key + index"
          v-show="active == index"
        >
          <div class="skill-info" v-show="!showSkillCompare">
            <div class="skill">
              <BorderBg />
              <div class="skill-name">
                {{ currentSkill.name.value }}
              </div>
              <div class="skill-icon">
                <img class="icon" :src="currentSkill.icon.value" alt="" />
              </div>
              <div class="skill-cd">冷却：{{ currentSkill.cd.value }}</div>
              <div class="skill-type">类型：{{ currentSkill.type.value }}</div>
              <div class="skill-compare" @click="triggerCompare">
                <img src="@/assets/nikke_imgs/skill-detail-icon.png" alt="" />
                技能对比
              </div>
            </div>
            <div class="skill-detail">
              <div class="detail-item skill-desc">
                <div class="label">技能描述</div>
                <div class="value">
                  <span v-html="formatText(currentSkillLevel.desc.value, notes)"></span>
                </div>
              </div>
              <div
                class="detail-item skill-upgrade"
                v-if="
                  !Object.keys(currentSkillLevel.upgrade)
                    .slice(0, 4)
                    .every(key => !currentSkillLevel.upgrade[key].icon.hasValue)
                "
              >
                <div class="label">升级所需</div>
                <div class="value">
                  <!-- <template> -->
                  <template v-for="(key, index) in Object.keys(currentSkillLevel.upgrade).slice(0, 4)">
                    <div
                      class="upgrade-item"
                      :key="index"
                      v-if="currentSkillLevel.upgrade[key].icon.hasValue && currentSkillLevel.upgrade[key].icon.value"
                    >
                      <img :src="currentSkillLevel.upgrade[key].icon.value" alt="" />
                      <span class="num">+{{ currentSkillLevel.upgrade[key].num.value }}</span>
                    </div>
                  </template>
                  <!-- </template>
                  <template v-else>
                    /
                  </template> -->
                </div>
              </div>
              <div
                class="detail-item skill-intensify"
                v-if="currentSkill.zpqh.desc.hasValue && currentSkill.zpqh.desc.value"
              >
                <div class="label">
                  <div>珍藏品强化</div>
                  <div>LV.10</div>
                </div>
                <div class="value">
                  <span v-html="formatText(currentSkill.zpqh.desc.value, notes)"></span>
                </div>
              </div>
            </div>
            <div class="skill-level">
              <BorderBg />
              <div class="level-wrapper" @mousewheel.prevent="handleLevelMouseWheel">
                <div class="level-list" :id="`listLevel—${index}`" style="top: 60px">
                  <div
                    class="item"
                    v-for="(key, index) in Object.keys(currentSkill.level)"
                    :key="index"
                    :class="{ active: activeLevel == index, 'is-sub': isSub(index) }"
                    @click="handleLevelChange(index)"
                  >
                    LV {{ index + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="compare-info" v-show="showSkillCompare">
            <div class="skill">
              <BorderBg />
              <div class="skill-icon">
                <img :src="currentSkill.icon.value" alt="" />
              </div>
              <div class="skill-name">{{ currentSkill.name.value }}</div>
              <div class="skill-cd">冷却：{{ currentSkill.cd.value }}</div>
              <div class="skill-type">类型{{ currentSkill.type.value }}</div>
              <div class="skill-compare" @click="triggerCompare">
                <img src="@/assets/nikke_imgs/skill-detail-icon.png" alt="" />
                技能详情
              </div>
            </div>
            <div class="compare-list">
              <div class="item" v-for="(key1, index) in Object.keys(currentSkill.level)" :key="index">
                <div class="label">LV {{ index + 1 }}</div>
                <div class="value">
                  <span v-html="formatText(currentSkill.level[key1].desc.value, notes)"></span>
                  <span class="upgrade-list">
                    <template v-for="(key, index) in Object.keys(currentSkill.level[key1].upgrade).slice(0, 4)">
                      <div
                        class="upgrade-item"
                        :key="index"
                        v-if="
                          currentSkill.level[key1].upgrade[key].icon.hasValue &&
                            currentSkill.level[key1].upgrade[key].icon.value
                        "
                      >
                        <img :src="currentSkill.level[key1].upgrade[key].icon.value" alt="" />
                        <span class="num">+{{ currentSkill.level[key1].upgrade[key].num.value }}</span>
                      </div>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-panel" v-show="active == 3">
          <div class="normal-attack-info">
            <div class="attack-weapon">
              <BorderBg />
              <div class="weapon-icon">
                <img :src="dataSource.ptgj.weapon.icon.value" alt="" />
              </div>
              <div class="weapon-name">
                {{ dataSource.ptgj.weapon.name.value }}
              </div>
            </div>
            <div class="info-list">
              <div class="line-1">
                <template v-for="key in Object.keys(dataSource.ptgj.list).slice(0, 4)">
                  <div
                    class="item"
                    :key="key"
                    v-if="dataSource.ptgj.list[key].label.hasValue && dataSource.ptgj.list[key].label.value"
                  >
                    <div class="label">
                      {{ dataSource.ptgj.list[key].label.value }}
                    </div>
                    <div class="value">
                      {{ dataSource.ptgj.list[key].value.value }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="line-2">
                <template v-for="key in Object.keys(dataSource.ptgj.list).slice(4)">
                  <div
                    class="item"
                    style="width: 100%;min-height: 64px;"
                    :key="key"
                    v-if="dataSource.ptgj.list[key].label.hasValue && dataSource.ptgj.list[key].label.value"
                  >
                    <div class="label">
                      {{ dataSource.ptgj.list[key].label.value }}
                    </div>
                    <div class="value" style="width: 100%;min-height: 64px;justify-content: flex-start;">
                      <span v-html="formatText(dataSource.ptgj.list[key].value.value, notes)"></span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-panel" v-show="active == 4">
          <div class="collection-info">
            <div class="collection">
              <BorderBg />
              <div class="collection-icon">
                <img :src="dataSource.zcp.weapon.icon.value" alt="" />
              </div>
              <div class="collection-name">
                {{ dataSource.zcp.weapon.name.value }}
              </div>

              <img class="collection-level" :src="dataSource.zcp.weapon.level.value" alt="" />
              <div class="collection-type">收集品</div>
            </div>
            <div class="info-list">
              <div class="line-1">
                <template v-for="key in Object.keys(dataSource.zcp.list).slice(0, 4)">
                  <div
                    class="item"
                    :key="key"
                    v-if="dataSource.zcp.list[key].label.hasValue && dataSource.zcp.list[key].label.value"
                  >
                    <div class="label">
                      {{ dataSource.zcp.list[key].label.value }}
                    </div>
                    <div class="value">
                      {{ dataSource.zcp.list[key].value.value }}
                    </div>
                  </div>
                </template>
              </div>

              <div class="line-2">
                <div class="value">
                  {{ dataSource.zcp.desc.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注释 -->
    <NotesPoppover ref="notesPoppover" />
  </ContainerBox>
</template>

<script>
import ContainerBox from "./containerBox.vue";
import BorderBg from "./borderBg.vue";
import { throttle } from "@/plugins/util";
import { formatText } from "../../utils";
import NotesPoppover from "../../components/NotesPoppover.vue";

export default {
  name: "SkillInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    notes: {
      typeof: Array,
      default: () => {
        return [];
      }
    }
  },
  components: { ContainerBox, BorderBg, NotesPoppover },
  data() {
    return {
      active: 0,
      activeLevel: 0,
      showSkillCompare: false,
      currentSkill: this.dataSource.list["s1"],
      currentSkillLevel: this.dataSource.list["s1"].level["l1"]
    };
  },
  watch: {
    dataSource: {
      handler(val) {
        if (this.active == 0) this.currentSkill = this.dataSource.list["s1"];
        else if (this.active == 1) this.currentSkill = this.dataSource.list["s2"];
        else if (this.active == 2) this.currentSkill = this.dataSource.list["s3"];
      },
      deep: true,
      immediate: true
    },
    currentSkill: {
      handler(val) {
        this.activeLevel = 0;
        this.currentSkillLevel = val.level["l1"];
        this.setLevelPostion();
        this.initPoppover();
      },
      deep: true
    }
  },
  mounted() {
    this.setLevelPostion();
    this.initPoppover();
  },
  methods: {
    formatText,
    initPoppover() {
      this.$nextTick(() => {
        const noteEls = document.querySelectorAll("[data-notes-value]");
        noteEls.forEach(el => {
          el.addEventListener("mouseenter", () => {
            this.$refs.notesPoppover.open(el, el.dataset.notesValue);
          });
        });
      });
    },
    handleTabChange(active) {
      this.active = active;
      this.activeLevel = 0;
      this.showSkillCompare = false;
      if (active == 0) this.currentSkill = this.dataSource.list["s1"];
      else if (active == 1) this.currentSkill = this.dataSource.list["s2"];
      else if (active == 2) this.currentSkill = this.dataSource.list["s3"];
      this.initPoppover();
    },
    triggerCompare() {
      this.showSkillCompare = !this.showSkillCompare;
    },
    handleLevelChange(level) {
      this.activeLevel = level;
      this.currentSkillLevel = this.currentSkill.level["l" + (level + 1)];
      this.setLevelPostion();
      this.initPoppover();
    },
    isSub(level) {
      return this.activeLevel - 1 == level || this.activeLevel + 1 == level;
    },
    handleLevelMouseWheel: throttle(function(e) {
      let level = this.activeLevel;
      if (e.deltaY > 0) {
        level += 1;
      } else {
        level -= 1;
      }
      this.handleLevelChange(level);
    }, 300),
    setLevelPostion() {
      if (this.activeLevel < 0) {
        this.activeLevel = 0;
      } else if (this.activeLevel > 9) {
        this.activeLevel = 9;
      }
      const listEl = document.getElementById("listLevel—" + this.active);
      listEl.style.top = 60 - this.activeLevel * 31 + "px";
    }
  }
};
</script>

<style lang="less" scoped>
.skill-info {
  display: flex;

  .skill {
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 128px;
    margin-top: 9px;
    padding-top: 18px;
    margin-right: 9px;
    .skill-name {
      position: absolute;
      top: -6px;
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      color: #3a3a3c;
      line-height: 16px;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .skill-icon {
      width: 57px;
      height: 57px;
      margin-bottom: 4px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .skill-cd,
    .skill-type {
      width: 78px;
      height: 26px;
      background: #45474a;
      border-radius: 4px 4px 4px 4px;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 26px;
      text-align: center;
      margin-bottom: 8px;
    }

    .skill-compare {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 12px;
      color: #3eafff;
      line-height: 14px;
      text-decoration: underline;
      margin-top: 2px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }
  }

  .skill-detail {
    width: 354px;
    margin-right: 7px;
    .detail-item {
      display: flex;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80px;
        min-height: 55px;
        background: #45474a;
        border-radius: 4px 0px 0px 4px;
        font-weight: 500;
        font-size: 12px;
        color: #f2f4f1;
        line-height: 14px;
      }
      .value {
        display: flex;
        align-items: center;
        width: 274px;
        min-height: 55px;
        background: #ffffff;
        border-radius: 0px 4px 4px 0px;
        padding: 8px;
        overflow: hidden;
      }
    }
    .upgrade-item {
      position: relative;
      width: 36px;
      height: 36px;
      background: linear-gradient(180deg, #d9d9d8 0%, #c1c1c1 100%);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dddde0;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
      .num {
        position: absolute;
        bottom: 0;
        right: 2px;
        font-weight: 500;
        font-size: 10px;
        color: #ffffff;
        line-height: 12px;

        // -webkit-text-stroke: 1px #45474a;
        text-shadow: 0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000, 0.5px 0.5px 0 #000;
      }
    }
  }

  .skill-level {
    position: relative;
    width: 78px;
    display: flex;
    align-items: center;
    overflow: hidden;
    &::before {
      position: absolute;
      top: 50%;
      left: -8px;
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-top: 2px solid #3a3a3c;
      border-right: 2px solid #3a3a3c;
      transform: rotate(45deg) translateY(-50%);
    }
    &::after {
      position: absolute;
      top: 50%;
      right: -2px;
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-bottom: 2px solid #3a3a3c;
      border-left: 2px solid #3a3a3c;
      transform: rotate(45deg) translateY(-50%);
    }
    .level-wrapper {
      position: relative;
      width: 78px;
      height: 186px;
      overflow: hidden;
    }

    .level-list {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: center;
      justify-content: center;
      padding: 27px 0;
      transition: all 0.3s;
      .item {
        width: 100%;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: rgba(58, 58, 60, 0.3);
        line-height: 16px;
        cursor: pointer;
        &.is-sub {
          color: rgba(58, 58, 60, 0.7);
        }
        &.active {
          position: relative;
          color: #3eafff;
        }
      }
    }
  }
}

.compare-info {
  display: flex;
  .skill {
    flex-shrink: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 128px;
    height: 186px;
    margin-top: 9px;
    padding-top: 10px;
    margin-right: 9px;

    .skill-icon {
      width: 44px;
      height: 44px;
      margin-bottom: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .skill-name {
      font-weight: 500;
      font-size: 14px;
      color: #3a3a3c;
      line-height: 16px;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 4px;
    }
    .skill-cd,
    .skill-type {
      width: 78px;
      height: 26px;
      background: #45474a;
      border-radius: 4px 4px 4px 4px;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 26px;
      text-align: center;
      margin-bottom: 4px;
    }

    .skill-compare {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 12px;
      color: #3eafff;
      line-height: 14px;
      text-decoration: underline;
      margin-top: 4px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }
  }

  .compare-list {
    width: 100%;
    margin-top: 9px;
    height: 186px;
    overflow-y: auto;

    .item {
      display: flex;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
      .label {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80px;
        min-height: 48px;
        background: #45474a;
        border-radius: 4px 0px 0px 4px;
        font-weight: 500;
        font-size: 14px;
        color: #f2f4f1;
        line-height: 14px;
      }
      .value {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: space-between;
        width: 100%;
        min-height: 48px;
        background: #ffffff;
        border-radius: 0px 4px 4px 0px;
        padding: 8px;
        .upgrade-list {
          flex-shrink: 0;
          display: flex;
          gap: 8px;
        }
        .upgrade-item {
          display: flex;
          flex-direction: column;
          gap: 2px;
          img {
            width: 22px;
            height: 22px;
            background: linear-gradient(180deg, #d9d9d8 0%, #c1c1c1 100%);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dddde0;
          }
          .num {
            font-weight: 500;
            font-size: 8px;
            color: #ffffff;
            text-align: center;
            line-height: 9px;
            text-shadow: 0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000, 0.5px 0.5px 0 #000;
          }
        }
      }
    }
  }
}

.normal-attack-info {
  display: flex;
  .attack-weapon {
    flex-shrink: 0;
    width: 128px;
    position: relative;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .weapon-icon {
      width: 94px;
      height: 94px;
      margin-bottom: 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .weapon-name {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: center;
    }
  }

  .info-list {
    .line-1 {
      width: 100%;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      margin-bottom: 10px;
    }
    .line-2 {
      width: 100%;
      display: flex;
    }
    .item {
      display: flex;
      width: calc(50% - 5px);
      height: 100%;
      .label {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 77px;
        min-height: 51px;
        background: #45474a;
        border-radius: 4px 0px 0px 4px;
        font-weight: 500;
        font-size: 14px;
        color: #f2f4f1;
        line-height: 16px;
      }
      .value {
        width: 139px;
        min-height: 51px;
        background: #ffffff;
        border-radius: 0px 4px 4px 0px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
      }
    }
  }
}

.collection-info {
  display: flex;
  .collection {
    flex-shrink: 0;
    width: 128px;
    height: 186px;
    position: relative;
    padding-top: 10px;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .collection-icon {
      width: 78px;
      height: 78px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #000000;
      margin-bottom: 6px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .collection-name {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      margin-bottom: 2px;
    }
    .collection-level {
      min-width: 30px;
      height: 30px;
      margin-bottom: 2px;
    }
    .collection-type {
      width: 78px;
      height: 22px;
      background: #45474a;
      border-radius: 4px 4px 4px 4px;
      font-weight: 500;
      font-size: 12px;
      color: #f6f7f9;
      line-height: 22px;
      text-align: center;
    }
  }
  .info-list {
    width: 100%;
    .line-1 {
      width: 100%;
      height: 36px;
      display: flex;
      gap: 10px;
      margin-bottom: 10px;
    }
    .line-2 {
      width: 100%;
      height: 140px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      .value {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 14px;
        padding: 10px;
      }
    }
    .item {
      display: flex;
      width: 100%;
      height: 100%;
      .label {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 100%;
        background: #45474a;
        border-radius: 4px 0px 0px 4px;
        font-weight: 500;
        font-size: 14px;
        color: #f2f4f1;
        line-height: 16px;
      }
      .value {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 0px 4px 4px 0px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
      }
    }
  }
}

.tabs {
  padding-bottom: 15px;
  .tab-bar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 52px;
    background-image: url("~@/assets/nikke_imgs/skill-tab-bar-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: #3a3a3c;
    padding: 6px 20px 0;
    .bar-item {
      min-width: 108px;
      height: 46px;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 4px 4px 0;
      cursor: pointer;
      &.active {
        background: #f2f2f5;
        .name {
          color: #030303;
        }
      }
      .icon {
        width: 22px;
        height: 22px;
        margin-bottom: 2px;
      }
      .name {
        width: 100%;
        font-weight: 500;
        font-size: 12px;
        color: #f6f7f9;
        line-height: 16px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: center;
      }
    }
  }
  .tab-container {
    padding-top: 16px;
  }
}
</style>
